import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';

const getInitialLanguage = () => {
  const storedLang = localStorage.getItem('i18nextLng');
  const browserLang = navigator.language.split('-')[0];
  return storedLang || (browserLang === 'de' ? 'de' : 'en');
};

i18n
  .use(initReactI18next)
  .init({
    resources: { en, de },
    fallbackLng: 'en',
    lng: getInitialLanguage(),
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;